import initialState from './initialstate';
import * as types from '../Actions/actiontypes';
import {HttpStatusCodes} from '../../../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function assignmentsReducer(state = initialState.assignment, action) {
	switch (action.type) {
		case types.HO_GET_ASSIGNMENTS: {
			return action.response;
		}
		case types.HO_CREATE_ASSIGNMENTS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Created) {
				// add response object into state
				let newState = _.cloneDeep(state);

				// set isNew as false
				newState.forEach((item) => {
					item.isNew = false;
				});

				// set new item as new
				let item = action.response;
				item.isNew = true;

				newState.push(item);

				// sort
				newState.sort((a, b) => {
					return a.assignmentTypeId - b.assignmentTypeId !== 0
						? a.assignmentTypeId - b.assignmentTypeId
						: b.name - a.name;
				});

				return newState;
			} else {
				return state;
			}
		}
		case types.HO_GET_MANAGE_ASSIGNMENTS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return [];
		}
		default:
			return state;
	}
}
